import script from "./AppsMiniList.vue?vue&type=script&setup=true&lang=js"
export * from "./AppsMiniList.vue?vue&type=script&setup=true&lang=js"

import "./AppsMiniList.vue?vue&type=style&index=0&id=505216c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-505216c2"]])

export default __exports__